// Generated by scripts/build-ui-icons.mjs.
export { X as default } from "../ui/glyphs-8";
